import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';

//import { Button, FormControlLabel, MenuItem, Radio, Typography, Icon, IconButton } from 'material-ui';
import { InputLabel, Select as MSelect, Radio, MenuItem, TextField, Checkbox, FormControlLabel, Divider, Button, Paper, Typography, FormControl, FormHelperText, Icon, IconButton } from 'material-ui';
import classNames from 'classnames';
import ReactTable from "react-table";
import axios from 'axios/index';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import Loader from "other-components/loader/loader";
import { withAlert } from 'react-alert';
import { TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';
import moment from 'moment';
import 'react-select/dist/react-select.css'
import Select from 'react-select';
import 'react-day-picker/lib/style.css';
import { confirmAlert } from 'react-confirm-alert';
import Tooltip from 'material-ui/Tooltip';

const styles = theme => ({
    layoutRoot: {},
    paper: { padding: '10px' },
    input: {
        'margin-top': 0
    }
});

var id = null;
var ID_CHEQUE_BOOK = null;
var chequeId = null;
var update_id = null;
var create_date = null;
var doc_number = null;
var bank_name = null;
var branch_name = null;
var acc_number = null;
var total_pages = null;
class CheckBook extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            banks: [],
            cheques: [],
            chequesEdit: [],
            bank: '',
            branches: [],
            branch: '',
            accounts: [],
            account: '',
            cheque_no: '',
            chequeLenght: 10,
            pageCounts: [{ value: '10', label: '10' }, { value: '20', label: '20' },
            { value: '25', label: '25' }, { value: '50', label: '50' },
            { value: '100', label: '100' }],
            pageCount: '',
            date: moment(new Date()).format("YYYY-MM-DD"),
            isActive: true,
            loading: false
        };


        this.loadBanks();
        this.loadData();

        this.handleSaveChequeBook = this.handleSaveChequeBook.bind(this);


    }



    loadData() {
        var resObj;
        // axios.get('http://localhost:5009/chequeBook/getChequeBookDetails')
        axios.get(window.accountServer + '/chequeBook/getChequeBookDetails')
            .then(response => {
                if (response.data.success) {
                    resObj = response.data.chequeBookDetails;
                    console.log(resObj)
                    this.appendToTable(resObj)
                }
            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

        // this.closeNewCustomerDialog();
    }



    appendToTable(checkBookObj) {

        console.log(checkBookObj)
        var data = [];
        var active;
        for (var i = 0; i < checkBookObj.length; i++) {
            if (checkBookObj[i].IS_ACTIVE == 1) {
                active = 'Active'
            } else {
                active = 'Inactive'

            }
            var create_date = checkBookObj[i].CREATED_DATE
            create_date = create_date.toString().substring(0, 10);
            data.push({
                update_id: checkBookObj[i].ID_CHEQUE_BOOK,
                // id: "B-" + checkBookObj[i].ID_LEDGER_ACCOUNT,
                create_date: create_date,
                doc_number: checkBookObj[i].DOCUMENT_NO,
                bank_name: checkBookObj[i].BANK_NAME,
                branch_name: checkBookObj[i].BRANCH_NAME,
                acc_number: checkBookObj[i].ACCOUNT_NO,
                total_pages: checkBookObj[i].PAGE_COUNT,
                // ledgerefNo: checkBookObj[i].LEDGER_REF_NO,
                // ledgerName: checkBookObj[i].NAME,
                // description: checkBookObj[i].DESCRIPTION,
                // ledgerCode: checkBookObj[i].LEDGER_CODE,
                // is_active: checkBookObj[i].IS_ACTIVE,
                // mainAccountId: checkBookObj[i].ID_MAIN_ACCOUNT,
                // active: active
            });

        }

        this.setState({ data: data });
        // this.setState({ loading: false });
    }



    loadBanks() {
        var banks = [];
        // axios.get('http://localhost:5009/bank/getBankDetails')
        axios.get(window.accountServer + '/bank/getBankDetails')
            .then(response => {

                for (let i = 0; i < response.data.bankDetails.length; i++) {
                    console.log("rrrr" + JSON.stringify(response.data.bankDetails[i].bank_name));
                    banks.push({
                        value: response.data.bankDetails[i].ID_BANK_ACCOUNT,
                        label: response.data.bankDetails[i].BANK_NAME
                    });
                }
                this.setState({ banks: banks });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    handleBank = (selectedOption) => {
        this.setState({
            bank: selectedOption
        });
        if (selectedOption != null) {
            this.loadBranches(selectedOption.label)
        }

    }

    handleBranch = (selectedOption) => {
        this.setState({
            branch: selectedOption
        });
        // alert(selectedOption)
        if (selectedOption != null && this.state.bank != null && this.state.bank != '') {
            this.loadAcounts(this.state.bank.label, selectedOption.label)
        }

    }

    handleAcount = (selectedOption) => {
        this.setState({
            account: selectedOption
        });
    }

    handlePageCount = (selectedOption) => {
        this.setState({
            pageCount: selectedOption
        });
    }

    handleCloseEdit = () => {
        this.setState({ edit: false });
    };

    handleCloseActive = () => {
        this.setState({ active: false });
    };

    handleCloseDelete = () => {
        this.setState({ delete: false });
    };
    handleSaveChequeBook = () => {
        // alert()
        if (this.state.cheques.length != 0) {
            this.setState({ cheques: [] });
            this.loadData();
            this.props.alert.success("ChequeBook Details added Successfully.");
            this.clearValue()
        }

    };

    // active cheque
    onActive = (model) => {
        this.chequeStatusChange(model, 1);
    }
    // delete department
    onDelete = (model) => {
        this.chequeStatusChange(model, 0);
    };

    chequeStatusChange(model, is_active) {

        const chequebj = {
            id: model.chequeId,
            is_active: is_active
        }
        var chequeNum = []
        var active;
        // axios.post('http://localhost:5009/chequeBook/updateChequeStatus', chequebj)
        axios.post(window.accountServer + '/chequeBook/updateChequeStatus', chequebj)
            .then(response => {
                if (response.data.success) {
                    this.loadCheckBookDetails(model.ID_CHEQUE_BOOK);
                    this.handleCloseActive()
                    this.handleCloseDelete()
                }

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

    }


    loadAcounts(bank, branch) {
        var accounts = [];
        const bankObj = {
            bank: bank,
            branch: branch
        }

        // axios.post('http://localhost:5009/bank/getBranchAcounts', bankObj)
        axios.post(window.accountServer + '/bank/getBranchAcounts', bankObj)
            .then(response => {
                if (response.data.accounts.length == 0) {
                    this.setState({ branches: [], branch: '' });
                } else {
                    for (let i = 0; i < response.data.accounts.length; i++) {
                        console.log("rrrr" + JSON.stringify(response.data.accounts[i].ACCOUNT_NO));
                        accounts.push({
                            value: response.data.accounts[i].ACCOUNT_NO,
                            label: response.data.accounts[i].ACCOUNT_NO
                        });
                    }
                    this.setState({ accounts: accounts });

                }


            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    loadBranches(bank) {
        var branches = [];
        const bankObj = {
            bank: bank
        }

        // axios.post('http://localhost:5009/bank/getBranchesByBankName', bankObj)
        axios.post(window.accountServer + '/bank/getBranchesByBankName', bankObj)
            .then(response => {
                if (response.data.bankBranches.length == 0) {
                    this.setState({ branches: [], branch: '' });
                } else {
                    for (let i = 0; i < response.data.bankBranches.length; i++) {
                        console.log("rrrr" + JSON.stringify(response.data.bankBranches[i].BRANCH));
                        branches.push({
                            value: response.data.bankBranches[i].ACCOUNT_NO,
                            label: response.data.bankBranches[i].BRANCH
                        });
                    }
                    this.setState({ branches: branches });

                }


            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    loadCheckBookDetails(id) {
        const chequebj = {
            id: id
        }
        var chequeNum = []
        var active;
        // axios.post('http://localhost:5009/chequeBook/getchequeById', chequebj)
        axios.post(window.accountServer + '/chequeBook/getchequeById', chequebj)
            .then(response => {
                if (response.data.chequeBookDetails.length == 0) {
                    // this.setState({ branches: [], branch: '' });
                } else {
                    for (let i = 0; i < response.data.chequeBookDetails.length; i++) {
                        console.log("rrrr" + JSON.stringify(response.data.chequeBookDetails[i].CHEQUE_NO));
                        if (response.data.chequeBookDetails[i].IS_ACTIVE == 1) {
                            active = 'Active'
                        } else {
                            active = 'Inactive'

                        }

                        chequeNum.push({
                            id: i + 1,
                            cheque_no: response.data.chequeBookDetails[i].CHEQUE_NO,
                            status: active,
                            chequeId: response.data.chequeBookDetails[i].ID_CHEQUE_BOOK_HEADER,
                            ID_CHEQUE_BOOK: response.data.chequeBookDetails[i].ID_CHEQUE_BOOK
                        })
                    }
                    this.setState({
                        chequesEdit: chequeNum,
                        chequeLenght: response.data.chequeBookDetails.length
                    });

                }


            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    onSubmit = (model) => {

        // alert(this.state.bank.label)

        if (this.state.bank.label == null || this.state.bank.label == "") {
            this.props.alert.error('select bank');
        } else if (this.state.branch.label == null || this.state.branch.label == "") {
            this.props.alert.error('selech branch');
        } else if (this.state.account.value == null || this.state.account.value == "") {
            this.props.alert.error('select acount number');
        } else if (this.state.pageCount.value == null || this.state.pageCount.value == "") {
            this.props.alert.error('select page count');
        } else {

            var start_num = model.start_num
            start_num = start_num.toString().substring(5, 6);
            var pageCount = this.state.pageCount.value;
            var chequeNum = []
            chequeNum.push({
                id: 1,
                cheque_no: parseInt(model.start_num),
                status: 'Active'

            })
            var chequeNumbers = model.start_num
            for (let i = 1; i < pageCount; i++) {
                chequeNumbers = parseInt(chequeNumbers) + 1
                chequeNum.push({
                    id: i + 1,
                    cheque_no: chequeNumbers,
                    status: 'Active'
                })
            }
            // console.log(chequeNum)
            this.setState({ cheques: chequeNum });
            this.saveCheckBook(model, chequeNum);
        }




    };

    saveCheckBook(model, chequeNum) {
        // alert("dd" + this.state.branch.value);
        // alert("dde" + this.state.account.value)

        const chequeBookObj = {
            date: model.date,
            doc_number: model.doc_number,
            bank_name: this.state.bank.label,
            bank_code: this.state.bank.value,
            branch_name: this.state.branch.label,
            acc_no: this.state.account.value,
            pageCount: this.state.pageCount.value,
            cheque: chequeNum,
            start_num: model.start_num,
            is_active: true
        }

        console.log(chequeBookObj)

        // axios.post('http://localhost:5009/chequeBook/createChequeBookDetails', chequeBookObj)
        axios.post(window.accountServer + '/chequeBook/createChequeBookDetails', chequeBookObj)
            .then(res => {

                if (res.data.success) {

                    // this.props.alert.success("Ledger Account Details added Successfully.");

                    const chequeBookObj = {
                        date: model.date,
                        doc_number: model.doc_number,
                        bank_name: this.state.bank.label,
                        bank_code: this.state.bank.value,
                        branch_name: this.state.branch.label,
                        acc_no: this.state.account.value,
                        pageCount: this.state.pageCount.value,
                        cheque: chequeNum,
                        start_num: model.start_num,
                        last_id: res.data.last_record[0].LAST_INSERT_ID,
                        is_active: true
                    }

                    console.log(chequeBookObj)

                    // axios.post('http://localhost:5009/chequeBook/createChequeBookHeaderDetails', chequeBookObj)
                    axios.post(window.accountServer + '/chequeBook/createChequeBookHeaderDetails', chequeBookObj)
                        .then(res => {

                            if (res.data.success) {

                                this.clearValue();
                                // this.loadData();

                            } else {
                                this.props.alert.error(res.data.message);
                            }
                        })

                } else {
                    // alert(res.data.message);
                    this.props.alert.error(res.data.message);
                }
            })
    }

    clearValue = () => {
        // alert()
        this.form.reset();
        this.setState({
            bank: '',
            branch: '',
            account: '',
            pageCount: '',
            // cheques: []
        });
    }

    componentWillMount() { }

    render() {
        const { classes } = this.props;

        var borderStyle = {
            'border-bottom': '4px solid darkgrey',
            'background-color': 'lightgrey',
            'border-style': 'inset'
        };

        if (this.state.loading) {
            return (<Loader />);
        }

        else {

            return (
                <div className="pl-8 ">
                    <div className="p-8">
                        <h2 className="subtitle-color">Create New Cheque Book</h2>
                    </div>
                    <Formsy
                        onValidSubmit={this.onSubmit}
                        onValid={this.enableButton}
                        onInvalid={this.disableButton}
                        ref={(form) => this.form = form}
                        className="flex flex-col justify-center"
                    >
                        <fieldset style={borderStyle} className="mt-8 mr-16  p-8 pb-16 check-book-form-color">
                            <div className="block">
                                <div className="w-full sm:w-1/2 md:w-1/4 px-8  inline-block">
                                    <div className="block" >Date</div>
                                    <TextFieldFormsy
                                        className="block"
                                        type="date"
                                        name='date'
                                        value={this.state.date}
                                        //defaultValue={this.state.latePaymentMonthlyCharge}
                                        className={classes.textField}
                                        //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                        //margin="normal"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                                <div className="w-full sm:w-1/2 md:w-1/4 px-8  inline-block">
                                    <div className="block" >Documnet Number</div>
                                    <TextFieldFormsy
                                        className="block"
                                        name='doc_number'
                                        //value={this.state.latePaymentMonthlyCharge}
                                        //defaultValue={this.state.latePaymentMonthlyCharge}
                                        className={classes.textField}
                                        //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                        //margin="normal"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>

                            </div>

                            <div className="block mt-16">
                                <div className="w-full sm:w-1/2 md:w-1/4 px-8  inline-block">
                                    Bank Name
                                <Select
                                        className=""
                                        name="form-field-name"
                                        placeholder="Select Bank"
                                        value={this.state.bank}
                                        onChange={this.handleBank}
                                        options={this.state.banks}
                                    />
                                </div>
                                <div className="w-full sm:w-1/2 md:w-1/4 px-8  inline-block">
                                    Branch Name
                                <Select
                                        className=""
                                        name="form-field-name"
                                        placeholder="Select Branch"
                                        value={this.state.branch}
                                        onChange={this.handleBranch}
                                        options={this.state.branches}
                                    />
                                </div>
                                <div className="w-full sm:w-1/2 md:w-1/4 px-8  inline-block">
                                    Account Number
                                <Select
                                        className=""
                                        name="form-field-name"
                                        placeholder="Select Account Number"
                                        value={this.state.account}
                                        onChange={this.handleAcount}
                                        options={this.state.accounts}
                                    />
                                </div>
                                <div className="w-full sm:w-1/2 md:w-1/4 px-8  inline-block">
                                    Page Count
                                <Select
                                        className=""
                                        name="form-field-name"
                                        placeholder="Select Page Count"
                                        value={this.state.pageCount}
                                        onChange={this.handlePageCount}
                                        options={this.state.pageCounts}
                                    />
                                </div>

                                
                                <div className="w-full sm:w-1/2 md:w-1/4 px-8  inline-block ">
                                    <div className="block" >Starting Number</div>
                                    <TextFieldFormsy
                                        className="block"
                                        id="start_num"
                                        name='start_num'
                                        required
                                        validations={{
                                            minLength: 6,
                                            maxLength: 6,
                                            isNumeric: true
                                        }}
                                        validationErrors={{
                                            minLength: 'This is not a valid  Number',
                                            maxLength: 'This is not a valid  Number',
                                            isNumeric: 'This is not a  Number'
                                        }}
                                        //value={this.state.latePaymentMonthlyCharge}
                                        //defaultValue={this.state.latePaymentMonthlyCharge}
                                        className={classes.textField}
                                        //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                        //margin="normal"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>

                                 <div className="w-full sm:w-1/2 md:w-3/4 px-8  inline-block">
                                 <DialogActions className=" justify-right pl-16  ">
                                <Button
                                    variant="raised"
                                    color="secondary"
                                    className="mx-16 mt-16 pb-15"
                                    aria-label="Save"
                                    type="submit"
                                //disabled={!canSubmit}
                                >
                                    Create
                                </Button>

                                <Button
                                    variant="raised"
                                    color="primary"
                                    className="mx-16 mt-16 pb-15"
                                    aria-label="Clear"
                                    onClick={this.clearValue}
                                //disabled={!canSubmit}
                                >
                                    Clear
                                </Button>

                            </DialogActions>
                                 </div>
                            </div>


                          
                           

                            <div className="checkbook-margin-second">

                                <ReactTable
                                    data={this.state.cheques}
                                    columns={[
                                        {
                                            Header: "No",
                                            accessor: "id",
                                            className: "justify-start",
                                            width: 100

                                        },
                                        {
                                            Header: "Cheque Number",
                                            className: "justify-start",
                                            accessor: "cheque_no",
                                            width: 300
                                        },
                                        {
                                            Header: 'Status',
                                            className: "justify-start",
                                            accessor: "status",
                                            width: 200,
                                            Cell: row => (

                                                <div className="flex items-center">
                                                    <Icon
                                                        className={row.original.status === 'Active' ? 'text-green-light'
                                                            : row.original.status === 'Inactive' ? 'text-red-light'
                                                                : 'text-orange-light'}
                                                        title={row.original.status === 'Active' ? 'Active'
                                                            : row.original.status === 'Inactive' ? 'Inactive'
                                                                : 'text-orange-light'}
                                                    >
                                                        {row.original.status === 'Active' ? 'check_circle'
                                                            : row.original.status === 'Inactive' ? `cancel`
                                                                : 'Other'}
                                                    </Icon>

                                                </div>
                                            )
                                        }
                                    ]}
                                    defaultPageSize={5}
                                    className="-striped -highlight"


                                />

                               <DialogActions className=" justify-right pl-16  ">
                                    <Button
                                        variant="raised"
                                        color="secondary"
                                        className="mx-16 mt-16 pb-15"
                                        aria-label="Save"
                                        type="button"
                                        //disabled={!canSubmit}
                                        onClick={this.handleSaveChequeBook}
                                    >
                                        Save
                                </Button>



                                </DialogActions>
                            </div>
                        </fieldset>
                    </Formsy>

                    <div className=""></div>
                    <div><h2 className="subtitle-color">Cheque Book View</h2></div>
                    <div className="checkbook-margin">
                        <ReactTable
                            data={this.state.data}
                            columns={[

                                {
                                    Header: "Create Date",
                                    className: "justify-start",
                                    accessor: "create_date"
                                },
                                {
                                    Header: "Document Number",
                                    className: "justify-start",
                                    accessor: "doc_number"
                                },
                                {
                                    Header: "Bank Name",
                                    className: "justify-start",
                                    accessor: "bank_name"
                                },
                                {
                                    Header: "Branch Name",
                                    className: "justify-start",
                                    accessor: "branch_name"
                                },
                                {
                                    Header: "Account Number",
                                    className: "justify-start",
                                    accessor: "acc_number"
                                },
                                {
                                    Header: "Total Pages",
                                    className: "justify-start",
                                    accessor: "total_pages"

                                },
                                {
                                    Header: "Action",
                                    maxWidth: 100,
                                    className: "justify-center",
                                    // accessor: "su",
                                    width: 128,
                                    Cell: row => (
                                        <div className="flex items-center w-8 h-8">
                                            <IconButton

                                                onClick={(e) => {
                                                    if (row) {
                                                        // alert(row.original.update_id)
                                                        id = row.original.update_id;

                                                        this.loadCheckBookDetails(id)
                                                        this.setState({ edit: true });
                                                    }

                                                }}

                                            >
                                                <Icon className="text-blue" title="Edit">mode_edit</Icon>
                                            </IconButton>
                                            <Dialog

                                                open={this.state.edit}
                                                onClose={this.handleCloseEdit}
                                                aria-labelledby="form-dialog-title"
                                            >
                                                <DialogTitle id="form-dialog-title">Edit Cheque Book Details</DialogTitle>
                                                <DialogContent className="flex flex-wrap">

                                                    <div className="block checkbook-margin">

                                                     <div class="flex h-auto mt-4">

                                                      <div class="w-full bg-white h-auto">

                                                        <ReactTable className="w-full"
                                                         getTrProps={(state, rowInfo, column) => {
                                                            return {
                                                                className: "cursor-pointer",
                                                                onClick: (e, handleOriginal) => {

                                                                }
                                                            }
                                                        }}
                                                            data={this.state.chequesEdit}
                                                            columns={[
                                                                {
                                                                    Header: "No",
                                                                    accessor: "id",
                                                                    className: "justify-center",
                                                                    width: 100

                                                                },
                                                                {
                                                                    Header: "Cheque Number",
                                                                    className: "justify-center",
                                                                    accessor: "cheque_no",
                                                                    width: 300
                                                                },
                                                                {
                                                                    Header: 'Status',
                                                                    className: "justify-center",
                                                                    accessor: "status",
                                                                    width: 200,


                                                                    Cell: row => (

                                                                        row.original.status === 'Active' ? (
                                                                            <div className="flex items-center  w-8 h-8">
                                                                                <Tooltip
                                                                                    enterDelay={300}
                                                                                    id="tooltip-controlled"
                                                                                    leaveDelay={300}
                                                                                    onClose={this.handleTooltipClose}
                                                                                    onOpen={this.handleTooltipOpen}
                                                                                    open={this.state.open}
                                                                                    placement="bottom"
                                                                                    title="Do you want to inactive ?"
                                                                                >
                                                                                    <IconButton
                                                                                        onClick={(e) => {
                                                                                            if (row) {

                                                                                                chequeId = row.original.chequeId;
                                                                                                ID_CHEQUE_BOOK = row.original.ID_CHEQUE_BOOK;
                                                                                                this.setState({ delete: true });

                                                                                            }
                                                                                        }}

                                                                                    >
                                                                                        <Icon className="text-green">check_circle</Icon>
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                                <Dialog
                                                                                    open={this.state.delete}
                                                                                    onClose={this.handleClose}
                                                                                    aria-labelledby="form-dialog-title"
                                                                                >
                                                                                    <DialogTitle id="form-dialog-title">Inactive Cheque</DialogTitle>
                                                                                    <DialogContent>

                                                                                        <div>
                                                                                            <Formsy
                                                                                                onValidSubmit={this.onDelete}
                                                                                                onValid={this.enableButtonDelete}
                                                                                                onInvalid={this.disableButtonDelete}
                                                                                                ref={(form) => this.form = form}
                                                                                                className="flex flex-col justify-center"
                                                                                            >

                                                                                                <TextFieldFormsy
                                                                                                    type="hidden"
                                                                                                    name="chequeId"
                                                                                                    value={chequeId}
                                                                                                />
                                                                                                <TextFieldFormsy
                                                                                                    type="hidden"
                                                                                                    name="ID_CHEQUE_BOOK"
                                                                                                    value={ID_CHEQUE_BOOK}
                                                                                                />

                                                                                                <div className="w-full">
                                                                                                    Are you sure inactive
                                                                                            </div>

                                                                                                <DialogActions>
                                                                                                    <Button onClick={this.handleCloseDelete} color="primary">
                                                                                                        Cancel
                                                                                            </Button>
                                                                                                    <Button color="primary" autoFocus
                                                                                                        type="submit"
                                                                                                    >
                                                                                                        inactive
                                                                                                </Button>
                                                                                                </DialogActions>
                                                                                            </Formsy>
                                                                                        </div>
                                                                                    </DialogContent>
                                                                                </Dialog>
                                                                            </div>
                                                                        ) : (
                                                                                <div className="flex items-center  w-8 h-8">

                                                                                    <Tooltip
                                                                                        enterDelay={300}
                                                                                        id="tooltip-controlled"
                                                                                        leaveDelay={300}
                                                                                        onClose={this.handleTooltipClose}
                                                                                        onOpen={this.handleTooltipOpen}
                                                                                        open={this.state.open}
                                                                                        placement="bottom"
                                                                                        title="Do you want to active ?"
                                                                                    >
                                                                                        <IconButton
                                                                                            onClick={(e) => {
                                                                                                if (row) {
                                                                                                    chequeId = row.original.chequeId;
                                                                                                    ID_CHEQUE_BOOK = row.original.ID_CHEQUE_BOOK;
                                                                                                    this.setState({ active: true });

                                                                                                }
                                                                                            }}

                                                                                        >
                                                                                            <Icon className="text-red">cancel</Icon>
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                    <Dialog
                                                                                        open={this.state.active}
                                                                                        onClose={this.handleClose}
                                                                                        aria-labelledby="form-dialog-title"
                                                                                    >
                                                                                        <DialogTitle id="form-dialog-title">Active Cheque</DialogTitle>
                                                                                        <DialogContent>

                                                                                            <div>
                                                                                                <Formsy
                                                                                                    onValidSubmit={this.onActive}
                                                                                                    onValid={this.enableButtonDelete}
                                                                                                    onInvalid={this.disableButtonDelete}
                                                                                                    ref={(form) => this.form = form}
                                                                                                    className="flex flex-col justify-center"
                                                                                                >

                                                                                                    <TextFieldFormsy
                                                                                                        type="hidden"
                                                                                                        name="chequeId"
                                                                                                        value={chequeId}
                                                                                                    />

                                                                                                    <TextFieldFormsy
                                                                                                        type="hidden"
                                                                                                        name="ID_CHEQUE_BOOK"
                                                                                                        value={ID_CHEQUE_BOOK}
                                                                                                    />

                                                                                                    <div className="w-full">
                                                                                                        Are you sure active
                                                                                        </div>

                                                                                                    <DialogActions>
                                                                                                        <Button onClick={this.handleCloseActive} color="primary">
                                                                                                            Cancel
                                                                                            </Button>
                                                                                                        <Button color="primary" autoFocus
                                                                                                            type="submit"
                                                                                                        >
                                                                                                            Active
                                                                                                </Button>
                                                                                                    </DialogActions>
                                                                                                </Formsy>
                                                                                            </div>
                                                                                        </DialogContent>
                                                                                    </Dialog>

                                                                                </div>)
                                                                    )


                                                                }
                                                            ]}
                                                            defaultPageSize={5}
                                                            className="-striped -highlight"
                                                        />
                                                        </div>
                                                        </div>
                                                        <br />
                                                    </div>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button type="button" onClick={this.handleCloseEdit} variant="raised" size="small" color="primary" className="{classes.button} w-full default-btn-size  md:h-24">
                                                        Close
                                                                        </Button>

                                                </DialogActions>
                                            </Dialog>
                                        </div>
                                    )
                                }
                            ]}
                            //pageSize={this.state.records.length > 3 ? this.state.records.length : 3}
                            defaultPageSize={5}
                            className="-striped -highlight"
                        />
                    </div>
                </div>
            )


        }
    }



}

export default withStyles(styles, { withTheme: true })(withAlert(CheckBook));


// WEBPACK FOOTER //
// ./src/main/content/accounting/checkBook/CheckBook.js